// @ts-nocheck
import fallbackImage from "@assets/images/fallback-image.svg";
import {useGetNewGames} from "@hooks/gamesList/useGetNewGames";
import React from "react";
import {useNavigate} from "react-router-dom";
import {GameCarouselRow} from "@/components";
import {useAuthStore} from "@/store/useAuth.store";
import {
  gameCardCls,
  gameCardImageCls,
  gameCardNameCls,
  gameCardOverlayCls,
  gameCardPlayBtnCls,
} from "../_gameCardShared";

const newTagCls =
  "absolute top-2 right-2 w-[57px] h-6 rounded-[var(--radius-sm)] px-[var(--space-1-5)] py-[var(--space-0-5)] bg-[linear-gradient(90deg,var(--color-accent-orange-bright)_0%,var(--color-accent-magenta)_100%)] font-[Open_Sans,sans-serif] font-bold text-xs text-[var(--color-gray-1)] flex items-center justify-center z-[2] pointer-events-none transition-opacity duration-200 opacity-100 group-hover:opacity-0";

export const RecentGames = ({provider}) => {
  const {data} = useGetNewGames(provider && provider !== "all" ? provider : undefined);
  const recentGames = data?.data?.data || [];
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  const getGameIcon = game => {
    if (game.custom_icon && game.custom_icon.trim() !== "") {
      if (game.custom_icon.startsWith("http")) return game.custom_icon;
      return `https://images.cdn.raspaygana.com.ve/${game.custom_icon}`;
    }
    return game.icon || fallbackImage;
  };

  const handleGameClick = React.useCallback(
    (gameProvider, gameId) => {
      if (authStatus === "authenticated") {
        navigate(`/games/${gameProvider}/${gameId}`);
      } else {
        handleShowAuthModal();
      }
    },
    [authStatus, navigate, handleShowAuthModal]
  );

  function shuffle(array) {
    const arr = array.slice();
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  const displayGames = React.useMemo(() => shuffle(recentGames).slice(0, 6), [recentGames]);

  const renderCard = (game, idx) => (
    <div
      key={game.id || idx}
      className={gameCardCls}
      onClick={() => handleGameClick(game.provider?.name || game.provider, game.provider_game_id)}
    >
      <img
        src={getGameIcon(game)}
        alt={game.name}
        onError={e => {
          e.target.onerror = null;
          e.target.src = fallbackImage;
        }}
        className={gameCardImageCls}
      />
      <span className={newTagCls}>NUEVO</span>
      <div className={gameCardOverlayCls}>
        <span className={gameCardNameCls}>{game.name}</span>
        <button
          type="button"
          className={gameCardPlayBtnCls}
          onClick={e => {
            e.stopPropagation();
            handleGameClick(game.provider?.name || game.provider, game.provider_game_id);
          }}
        >
          Jugar Ya
        </button>
      </div>
    </div>
  );

  return (
    <GameCarouselRow
      id="recentGames"
      icon="💎"
      title="Recién llegados"
      subtitle="Llegaron de último pero pagan duro"
      subtitleIcon="💰"
      viewAllPath="/gameslist/all"
    >
      {displayGames.map((game, idx) => renderCard(game, idx))}
    </GameCarouselRow>
  );
};
